import ScoreCardsHistoryPage from './ScoreCardsHistoryPage';

export default ScoreCardsHistoryPage;


// WEBPACK FOOTER //
// ./src/features/score-card/pages/score-cards-history-page/index.js